import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { AdminAddVenueFormComponent } from "../components";
import { AdminDefaultLayout } from "../layouts/adminDefaultLayout";
// const userFormData = [
//   {
//     name: '',
//     type: 'text',
//   },
//   {
//     email: '',
//     type: 'email',
//   },
// ];

const columns = [
  { header: "Name", propName: "name" },
  { header: "Street", propName: "street" },
  { header: "State", propName: "usState.label" },
  // Add other columns as needed
];

const actions = [
  {
    name: "Edit",
    method: (item: any) => {
      /* handle edit */
    },
  },
  {
    name: "Delete",
    method: (item: any) => {
      /* handle delete */
    },
  },
];

export const AdminVenuesComponent = () => {
  const [formOpen, setFormOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [inputs, setInputs] = useState({});
  // const validationFunction = (data: any) => {
  //   console.log('data', data);
  //   // anything in userFormData !== '' is valid
  // };

  const [editingVenue, setEditingVenue] = useState({});
  const handleFormButtonClick = () => {
    setFormOpen(!formOpen);
  };

  const handleVenueButtonClick = (e: any) => {
    console.log("opened form for editing", e);
    setIsEditing(true);
    setEditingVenue(e);
    setFormOpen(!formOpen);
  };

  const setReset = () => {
    if (isEditing) {
      //reset to defaults
      setEditingVenue({});
      setIsEditing(false);
      setFormOpen(!formOpen);
    } else {
      setFormOpen(!formOpen);
    }
  };
  return (
    <>
      <AdminDefaultLayout
        openForm={handleFormButtonClick}
        formButtonTitle="Venue"
        actions={actions}
        columns={columns}
        header="Venues"
        searchType="venue"
        onItemSelect={handleVenueButtonClick}
      ></AdminDefaultLayout>
      <Modal show={formOpen} onHide={handleFormButtonClick} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Add Venue</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AdminAddVenueFormComponent
            closeForm={handleFormButtonClick}
            data={editingVenue}
            setInputs={setInputs}
            editing={isEditing}
            setReset={setReset}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};
